"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSingleAccordionOpen = exports.SingleOpenAccordionContext = exports.AllowSingleOpenAccordion = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const SingleOpenAccordionContext = exports.SingleOpenAccordionContext = /*#__PURE__*/(0, _react.createContext)([undefined, function () {}]);
const AllowSingleOpenAccordion = function (_ref) {
  let {
    children,
    defaultOpenAccordionId,
    useState = _react.useState
  } = _ref;
  const [singleOpenAccordionId, setSingleOpenAccordionId] = useState(defaultOpenAccordionId);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SingleOpenAccordionContext.Provider, {
    value: [singleOpenAccordionId, setSingleOpenAccordionId],
    "data-testid": "AllowSingleOpenAccordion",
    children: children
  });
};
exports.AllowSingleOpenAccordion = AllowSingleOpenAccordion;
const useSingleAccordionOpen = function () {
  const context = (0, _react.useContext)(SingleOpenAccordionContext);
  return context || [undefined, function () {}];
};
exports.useSingleAccordionOpen = useSingleAccordionOpen;